import { render } from "./FinancialSector.vue?vue&type=template&id=ca9e1cc2&scoped=true"
import script from "./FinancialSector.vue?vue&type=script&lang=js"
export * from "./FinancialSector.vue?vue&type=script&lang=js"

import "./FinancialSector.vue?vue&type=style&index=0&id=ca9e1cc2&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca9e1cc2"]])

export default __exports__